export const STRIPE_FIELDS = {
  GROUP: "group",
  CARD_NUMBER: "cardNumber",
  CARD_EXPIRY: "cardExpiry",
  CARD_CVC: "cardCvc",
  IBAN: "iban",
};
